/*
 * @Description  :
 * @Author       : 王帅
 * @Date         : 2024-07-18 10:07:37
 * @LastEditors  : 王帅
 * @LastEditTime : 2026-08-19 16:29:53
 * @FilePath     : \ngs_platform_manage_admin\src\api\modules\notification.js
 */
// 系统通知页面的 接口集合
import request from '../request.js'

// 新增或编辑通知 ---- 俞祥东
export const addNotice = function (data) {
    return request({
        url: 'operateSysNotice/saveOrEditNoticeInfo',
        method: 'post',
        data
    })
}

// 通知列表回显 ---- 俞祥东
export const getList = function (data) {
    return request({
        url: 'operateSysNotice/selectNoticeInfoByPage',
        method: 'post',
        data
    })
}

// 删除通知 ---- 俞祥东
export const deleteNotice = function (data) {
    return request({
        url: 'operateSysNotice/delNoticeInfoById',
        method: 'post',
        data
    })
}

// 通知状态改变 ---- 俞祥东
export const editStatus = function (data) {
    return request({
        url: 'operateSysNotice/setNoticeStatus',
        method: 'post',
        data
    })
}
// 查看浏览记录 ---- 俞祥东
export const getRecordsDetail = function (data) {
    return request({
        url: 'operateSysNoticeRead/selectNoticeReadInfoByPage',
        method: 'post',
        data
    })
}

// 系统通知置顶 ---- 李同雷
export const editSysNoticeTop = function (data) {
    return request({
        url: '/operateSysNotice/editSysNoticeTop',
        method: 'post',
        data
    })
}
